import { getCustomerDisplayName } from '../conversation/overview/customerDisplay';
import { formatPhone } from '../../utility/formatPhone';

/** Render saved contact fields consistently; never manufacture missing identities. */
export const ticketContact = (ticket) => ({
  name: getCustomerDisplayName(ticket.name),
  phone: formatPhone(ticket.phone, 'Not provided'),
});
export const ticketConversationLink = (ticket, appId) => {
  const id = ticket.conversationMongoId || ticket.conversationId;
  if (!id || !appId) return null;
  const path = String(ticket.channel || '').toLowerCase() === 'sip'
    ? '/admin/conversations/telephony/message/v1/details/'
    : '/admin/conversations/summery/';
  return `${path}${encodeURIComponent(id)}?appId=${encodeURIComponent(appId)}`;
};
